/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Day_SundayInputs */

const en_coach_day_sunday = /** @type {(inputs: Coach_Day_SundayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sunday`)
};

const de_coach_day_sunday = /** @type {(inputs: Coach_Day_SundayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sonntag`)
};

/**
* | output |
* | --- |
* | "Sunday" |
*
* @param {Coach_Day_SundayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_day_sunday = /** @type {((inputs?: Coach_Day_SundayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Day_SundayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_day_sunday(inputs)
	return de_coach_day_sunday(inputs)
});